import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { KYDAdminEvent } from "@common/interfaces/KYDEvent";
import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CreateLink,
  MDXEditor,
  UndoRedo,
  headingsPlugin,
  linkDialogPlugin,
  linkPlugin,
  toolbarPlugin,
} from "@mdxeditor/editor";
import { EditModalType, markdownToLineBreaks } from "../../../utils";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const EditDescriptionModal = ({
  setModalType,
  isLoading = false,
  isOpen = false,
  data,
  onSave,
}: {
  isLoading: boolean;
  isOpen?: boolean;
  data?: Pick<KYDAdminEvent, "description">;
  onSave: (values: { description: string }) => void;
  setModalType: (modalType: EditModalType) => void;
}) => {
  const { watch, setValue, handleSubmit } = useForm({
    criteriaMode: "all",
    reValidateMode: "onChange",
    mode: "all",
    values: {
      description: markdownToLineBreaks(data?.description) || "",
    },
  });
  const description = watch("description");

  const _onSave = (values: { description: string }) => {
    onSave({ description });
  };

  return (
    <Modal
      size={"3xl"}
      isOpen={isOpen}
      onClose={() => setModalType(EditModalType.INACTIVE)}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Description</ModalHeader>
        <ModalBody>
          <Box
            minH={"400px"}
            borderWidth={1}
            borderColor={"gray.300"}
            borderRadius={"md"}
          >
            <MDXEditor
              contentEditableClassName="mdx-editor"
              readOnly={isLoading}
              onChange={(value) => {
                setValue("description", markdownToLineBreaks(value), {
                  shouldDirty: true,
                  shouldValidate: true,
                });
              }}
              markdown={description}
              plugins={[
                headingsPlugin(),
                linkPlugin(),
                linkDialogPlugin(),
                toolbarPlugin({
                  toolbarContents: () => (
                    <>
                      {" "}
                      <BlockTypeSelect />
                      <BoldItalicUnderlineToggles />
                      <UndoRedo />
                      <CreateLink />
                    </>
                  ),
                }),
              ]}
            />
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button
            isDisabled={isLoading}
            onClick={() => {
              setModalType(EditModalType.INACTIVE);
            }}
            mr="4"
          >
            Cancel
          </Button>
          <Button
            color="white"
            bg="green.500"
            isLoading={isLoading}
            onClick={handleSubmit(_onSave)}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditDescriptionModal;
